'use strict';
var __importDefault =
	(this && this.__importDefault) ||
	function (mod) {
		return mod && mod.__esModule ? mod : {default: mod};
	};
Object.defineProperty(exports, '__esModule', {value: true});
exports.variantsProducts = exports.productDetails = exports.productListDetails = exports.productPricingFragment = void 0;
const graphql_tag_1 = __importDefault(require('graphql-tag'));
const products_1 = require('../fragments/products');
exports.productPricingFragment = graphql_tag_1.default`
  fragment ProductPricingField on Product {
    pricing {
      onSale
      priceRangeUndiscounted {
        start {
          ...Price
        }
        stop {
          ...Price
        }
      }
      priceRange {
        start {
          ...Price
        }
        stop {
          ...Price
        }
      }
    }
  }
`;
exports.productListDetails = graphql_tag_1.default`
  ${products_1.basicProductFragment}
  ${exports.productPricingFragment}
  query ProductList(
    $id: ID!
    $attributes: [AttributeInput]
    $after: String
    $pageSize: Int
    $sortBy: ProductOrder
    $priceLte: Float
    $priceGte: Float
  ) {
    products(
      after: $after
      first: $pageSize
      sortBy: $sortBy
      filter: {
        attributes: $attributes
        categories: [$id]
        minimalPrice: { gte: $priceGte, lte: $priceLte }
      }
    ) {
      totalCount
      edges {
        node {
          ...BasicProductFields
          ...ProductPricingField
          category {
            id
            name
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
    }
  }
`;
exports.productDetails = graphql_tag_1.default`
  ${products_1.basicProductFragment}
  ${products_1.selectedAttributeFragment}
  ${products_1.productVariantFragment}
  ${exports.productPricingFragment}
  query ProductDetails($id: ID!, $countryCode: CountryCode) {
    product(id: $id) {
      ...BasicProductFields
      ...ProductPricingField
      descriptionJson
      category {
        id
        name
        products(first: 3) {
          edges {
            node {
              ...BasicProductFields
              ...ProductPricingField
              category {
                id
                name
              }
            }
          }
        }
      }
      images {
        id
        url
      }
      attributes {
        ...SelectedAttributeFields
      }
      variants {
        ...ProductVariantFields
      }
      seoDescription
      seoTitle
      isAvailable
    }
  }
`;
exports.variantsProducts = graphql_tag_1.default`
  query VariantsProducts($ids: [ID]) {
    productVariants(ids: $ids, first: 100) {
      edges {
        node {
          id
          product {
            id
            leadTime
            productType {
              isShippingRequired
            }
            merchant {
              id
              name
              storeHourStart
              storeHourEnd
              operatingDays
              storeTitle
              storeDescription
              slug
              logo {
                url
              }
            }
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=products.js.map
